import React, { memo } from 'react';
import PropTypes from 'prop-types';

import bn from '../../generalUtils/benames';
const bem = bn.create('profileAvatar');

const ProfileAvatar = ({
  displayName = '',
  isActive = false,
  userReady = 1,
  size = 'lg',
  color = 'primary',
  className = 'my-3',
  activeCircleVisible = true,
  id = null,
  onClick = () => {},
  title = null,
  ...restProps
}) => {
  const isFullName = (displayName = '') => {
    return displayName?.includes(' ') || displayName?.length > 2;
  };
  const getInitials = (name = '') => {
    const words = name
      ?.replace(/[^+1-9a-zA-Z\s]/g, '')
      ?.split(' ')
      ?.filter(Boolean);
    const initials = words
      ?.slice(0, 2)
      ?.map(word => word?.charAt(0).toUpperCase())
      ?.join('');

    return initials?.length > 2 ? initials?.substring(0, 2) : initials;
  };
  const initials = isFullName(displayName) ? getInitials(displayName) : displayName;

  const profileLoaded = Boolean(displayName);
  const isActiveBoolean = typeof isActive === 'boolean' ? isActive : isActive === 1;
  const isUserReadyBoolean = userReady === 0;

  const iconClass = profileLoaded
    ? isActiveBoolean
      ? 'text-success' // Active status
      : 'text-danger' // Inactive status
    : 'text-dark-100'; // Default status when not loaded

  // Map size prop to appropriate class names
  const sizeClassMap = {
    sm: 'avatar--sm avatar-font--sm',
    md: 'avatar--md avatar-font--md',
    lg: 'avatar--lg avatar-font--lg',
    xl: 'avatar--xl avatar-font--xl'
  };

  const avatarSizeClass = sizeClassMap[size] || sizeClassMap['md'];
  const spanTitle = title ? title : isUserReadyBoolean ? 'Invitation not accepted' : displayName;

  return (
    <div className={bem.b(className)} id={id}>
      <div className={`clickable d-flex justify-content-center`}>
        <div className={`avatar-image avatar-image--loaded ${avatarSizeClass}`}>
          <div className="avatar avatar-image__image">
            {activeCircleVisible && (
              <div className="avatar__icon avatar__icon--stack">
                <i className="text-dark-900 fa fa-circle" />
                <i className={`fa fa-circle ${iconClass}`} />
              </div>
            )}
            <div className="avatar__content">
              <div
                className={`avatar-font ${avatarSizeClass} ${
                  isUserReadyBoolean ? 'btn-secondary' : `btn-${color}`
                }`}
                title={spanTitle}
              >
                <span className="avatar-font__text" onClick={onClick} {...restProps}>
                  {profileLoaded ? initials?.toUpperCase() : ''}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileAvatar.propTypes = {
  displayName: PropTypes.string,
  isActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  userReady: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  color: PropTypes.string,
  className: PropTypes.string,
  activeCircleVisible: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  title: PropTypes.string
};

ProfileAvatar.displayName = 'ProfileAvatar';
export default memo(ProfileAvatar);
